module.exports = __webpack_public_path__ + "img/wakad_image.1c494203.png";